import { takeLatest, call, put, all } from 'redux-saga/effects';
import { pullUserCategories } from '../_utils/fund-ranking.utils';

import {
  fetchRankingSearchFiltersSuccess,
  fetchRankingSearchFiltersFailure,
  fetchRankingsSuccess,
  fetchRankingsFailure,
  fetchCategoriesSuccess,
  fetchCategoriesFailure,
  fetchUserCategoriesStart,
  fetchUserCategoriesSuccess,
  fetchUserCategoriesFailure,
  saveUserCategoriesSuccess,
  saveUserCategoriesFailure,
  setDefaultFundRankingQueries,
  fetchNavRankingsSuccess,
  fetchNavRankingsFailure,
  fetchFundRankSuccess,
  fetchFundRankFailure,
  fetchHighlightFundSuccess,
  fetchHighlightFundFailure,
  fetchRankSuccess,
  fetchRankFailure,
  updateUserCategories
} from '../_actions/fund-ranking.actions';
import { fundRankingConstants } from '../_constants/fund-ranking.constants';

import {
  fetchCategories,
  fetchUserCategories,
  saveUserCategories,
  fetchFundRank,
  fetchRank
} from '../_services/fund-ranking.services';
import {
  fetchAdvanceSearchFilters,
  fetchNavForAdvanceSearch
} from '../_services/advance-search.services';
import {
  fetchHighlightFunds
} from '../_services/home.services';
import { fetchFundSearch } from '../_services/information.services';

import { store } from '../redux/store';

export function* fetchRankingSearchFiltersAsync() {
	try {
		const result = yield call(fetchAdvanceSearchFilters);
		yield put(fetchRankingSearchFiltersSuccess(result.data));
    yield put(setDefaultFundRankingQueries(result.data));
	} catch (error) {
		yield put(fetchRankingSearchFiltersFailure(error));
	}
}

export function* fetchRankingSearchFiltersStart() {
  yield takeLatest(fundRankingConstants.FETCH_RANK_SEARCH_FILTERS_START, fetchRankingSearchFiltersAsync);
}

export function* fetchFundRankAsync({payload}) {
	try {
		const result = yield call(fetchFundRank, payload);
		yield put(fetchFundRankSuccess(result.data));
	} catch (error) {
		yield put(fetchFundRankFailure(error));
	}
}

export function* fetchFundRankStart() {
  yield takeLatest(fundRankingConstants.FETCH_FUND_RANK_START, fetchFundRankAsync);
}

export function* fetchNavRankingsAsync({ payload }) {
	try {
		const result = yield call(fetchNavForAdvanceSearch, payload);
		yield put(fetchNavRankingsSuccess(result.data));
	} catch (error) {
		yield put(fetchNavRankingsFailure(error));
	}
}

export function* fetchNavRankingsStart() {
  yield takeLatest(fundRankingConstants.FETCH_NAV_RANKINGS_START, fetchNavRankingsAsync);
}

export function* fetchRankStartAsync({ payload }) {
  const { page } = payload;
  delete payload.page;
  try {
    const result = yield call(fetchRank, payload);
    yield put(fetchRankSuccess(result.data));
  } catch (error) {
    yield put(fetchRankFailure(error.message));
  }
}

export function* fetchRankStart() {
  yield takeLatest(fundRankingConstants.FETCH_RANK_START, fetchRankStartAsync);
}

export function* fetchRankingsStartAsync({payload}) {
  try {
    const result = yield call(fetchFundSearch, payload);
    yield put(fetchRankingsSuccess(result.data));
    // add page & current for in the future
    // yield put(updatePage(result.data.currentPage));
    // yield put(setTotalPage(result.data.totalPage));
  } catch (error) {
    yield put(fetchRankingsFailure(error.message));
    // yield put(updatePage(1));
    // yield put(setTotalPage(1));
  }
}

export function* fetchRankingsStart() {
  yield takeLatest(fundRankingConstants.FETCH_RANKINGS_START, fetchRankingsStartAsync);
}

export function* fetchCategoriesStartAsync() {
  const { authentication, fundRanking: { userCategory : { userCategories } } } = store.getState();
  // let user = state.authentication.currentNumbers.toString();

  try {
    if (!authentication.isSignIn && userCategories.length > 1) {
      return
    }
    yield put(updateUserCategories({ isFetching: true }));
    const first = yield call(fetchCategories);
    yield put(fetchCategoriesSuccess(first.data));
    // user = user !== '' ? 'User2' : null; //Change to username instant 'User2' later
    const second = yield call(fetchUserCategories);
    const data = pullUserCategories(second.data, first.data);
    yield put(fetchUserCategoriesSuccess(data));
  } catch (error) {
    yield put(fetchCategoriesFailure(error.message));
    yield put(fetchUserCategoriesFailure(error.message));
  }
}

export function* fetchCategoriesStart() {
  yield takeLatest(fundRankingConstants.FETCH_CATEGORIES_START, fetchCategoriesStartAsync);
}

export function* fetchUserCategoriesStartAsync() {
  const state = store.getState();
  const categories = state.fundRanking.category.categories;
  try {
    if (categories == null) {
      return;
    }

    const result = yield call(fetchUserCategories);
    const data = pullUserCategories(result.data, categories);
    yield put(fetchUserCategoriesSuccess(data));
  } catch (error) {
    yield put(fetchUserCategoriesFailure(error.message));
  }
}

export function* fetchUserCategoriesStartSaga() {
  yield takeLatest(fundRankingConstants.FETCH_USER_CATEGORIES_START, fetchUserCategoriesStartAsync);
}

export function* saveUserCategoriesStartAsync({ payload }) {
  const state = store.getState();
  let user = state.authentication.user;

  try {
    if (user) {
      // user = 'User2'; // remove this line after api have already request real username
      yield call(saveUserCategories, payload);
      yield put(fetchUserCategoriesStart(user));
    } else {
      yield put(fetchUserCategoriesSuccess(payload));
    }
  } catch (error) {
    yield put(saveUserCategoriesFailure(error.message));
  }
}

export function* saveUserCategoriesStart() {
  yield takeLatest(fundRankingConstants.SAVE_USER_CATEGORIES_START, saveUserCategoriesStartAsync);
}

export function* fetchHighlightFundStartAsync() {
  try {
    const result = yield call(fetchHighlightFunds);
    yield put(fetchHighlightFundSuccess(result.data));
  } catch (error) {
    yield put(fetchHighlightFundFailure(error.message));
  }
}

export function* fetchHighlightFundStart() {
  yield takeLatest(fundRankingConstants.FETCH_HIGHLIGHT_FUND_START, fetchHighlightFundStartAsync);
}

export function* fundRankingSagas() {
  yield all([
    call(fetchRankStart),
    call(fetchRankingSearchFiltersStart),
    call(fetchFundRankStart),
    call(fetchRankingsStart),
    call(fetchCategoriesStart),
    call(fetchUserCategoriesStartSaga),
    call(saveUserCategoriesStart),
    call(fetchNavRankingsStart),
    call(fetchHighlightFundStart)
  ]);
}
